export const initialFilter = {
  filter: {},
  pageNumber: 1,
  pageSize: 500,
};
